<template>
  <v-app id="welcome-wrap">
    <div>
      <!-- Header -->
      <header-welcome></header-welcome>

      <!-- Background -->
      <svg class="intro-background-image" :key="tree_key"
        :width="tree_width"
        :height="tree_height">
        <g>
          <g class="links">
            <g class="link"
              v-for="(link, index) in links" :key="index">
              <line class="line"
                :x1="link.source.x"
                :y1="link.source.y"
                :x2="link.target.x"
                :y2="link.target.y">
              </line>
            </g>
          </g>
          <g class="nodes">
            <g>
              <g class="node"
                v-for="(node, index) in nodes" :key="index">
                <circle
                  :r="(node.attributes[attr_node_size]+1)*2"
                  :fill="node_colors[node.attributes.color_index]"
                  :cx="node.x"
                  :cy="node.y"/>
              </g>
            </g>
          </g>
        </g>
      </svg>

      <!-- Contents -->
      <div class="contents">
        <section class="section-intro">
          <div class="intro">
            <div class="intro-title">
              <div>논문 작성을 위한</div>
              <div>가장 강력한 도구</div>
            </div>
            <div class="intro-subtitle">
              <div>당신의 참고문헌을 한 곳에서 관리하세요</div>
            </div>
            <div class="intro-btn" 
              @click="gaClick('welcome_btn_register1');register()">
              <v-btn depressed dark x-large color="pms205">
                30일 프리미엄 무료로 사용하기
              </v-btn>
            </div>
          </div>
        </section>

        <section class="section-feature section-feature-right">

          <div class="feature-image-wrapper">
            <v-card flat max-width="600px">
              <v-img src="/static/feature1.png" alt=""/>
            </v-card>
          </div>

          <div class="feature-text-right">
            <div class="feature-text">
              <div class="text-category">
                참고문헌 공유플랫폼, BiblioTrees
              </div>
              <div class="text-title">
                <div>학문적 맥락을 보여주는</div>
                <div>참고문헌 네트워크</div>
              </div>
              <div class="text-subtitle">
                <div>비블리오트리즈는 문헌의 서지사항을 <br> 
                여러 사용자가 공유하는 플랫폼입니다. <br>
                네트워크를 통해 논문에 필요한 자료를 <br> 
                빠르게 찾고 맥락을 파악할 수 있습니다. <br> 
                이제 당신의 참고자료를 <br> 
                목록이 아닌 네트워크로 관리하세요.</div>
              </div>
            </div>
          </div>

        </section>

        <section class="section-feature">

          <div class="feature-text-left">
            <div class="feature-text">
              <div class="text-category">
                랩과 연구 프로젝트
              </div>
              <div class="text-title">
                <div>공유플랫폼을 활용한</div>
                <div>나만의 랩과 프로젝트</div>
              </div>
              <div class="text-subtitle">
                <div>비블리오트리즈에는 당신만의 랩이 있습니다. <br>
                랩에 논문이나 글을 위한 프로젝트를 만들고 <br>
                문헌자료 네트워크를 발전시켜보세요. <br>
                입력이나 파일을 통해 필요한 문헌들을 <br>
                프로젝트에 추가할 수 있습니다.</div>
              </div>
            </div>
          </div>

          <div class="feature-image-wrapper feature-image-wrapper-right">
            <v-card flat max-width="600px">
              <v-img src="/static/feature2.png" alt=""/>
            </v-card>
          </div>

        </section>

        <section class="section-feature section-feature-right">

          <div class="feature-image-wrapper">
            <v-card flat max-width="600px">
              <v-img src="/static/feature3.png" alt=""/>
            </v-card>
          </div>

          <div class="feature-text-right">
            <div class="feature-text">
              <div class="text-category">
                참고문헌 리뷰와 워킹페이퍼
              </div>
              <div class="text-title">
                <div>리뷰를 한 눈에 보며</div>
                <div>작성하는 워킹페이퍼</div>
              </div>
              <div class="text-subtitle">
                <div>문헌에는 당신의 리뷰를 남길 수 있습니다. <br>
                프로젝트에 추가한 문헌에 남긴 리뷰를 <br>
                한 눈에 보면서 논문을 완성해보세요.<br>
                리뷰와 프로젝트 노트는 <br>
                워드파일로 내보낼 수 있습니다.</div>
              </div>
            </div>
          </div>

        </section>

        <section class="section-welcome">
          <div class="welcome-text">
            <div class="text-title">
              <div>새로운 직관의 세계</div>
            </div>
            <div class="text-subtitle-big">
              <div>
                <span>지식의 네트워크를</span> <span>보여주는 비블리오트리즈에서</span><br>
                <span>연구의 아이디어를 발전시킬 수 있는</span><br>
                <span>당신만의 랩을 만드세요</span>
              </div>
            </div>
            <div class="intro-btn" 
              @click="gaClick('welcome_btn_register2');register()">
              <v-btn depressed dark x-large block color="pms205">
                나의 랩 시작하기
              </v-btn>
            </div>
          </div>
        </section>
      </div>

      <!-- Footer -->
      <footer-welcome></footer-welcome>

    </div>
  </v-app>
</template>

<script>
import { doc_types } from '../../../custom/model'
import trees from '!raw-loader!../../../custom/welcome_trees.txt'
import { mapGetters } from 'vuex';
import { setInterval } from 'timers';

export default {
  metaInfo() {
    return {
      title: "Welcome"
    }
  },

  data() {
    return {
      doc_types: doc_types,
      trees: trees,
      node_colors: {},
      attr_node_size: 'in_degree',
      tree_key: 0,

      nodes: [],
      links: [],

      screen_width: window.innerWidth,
      screen_height: window.innerHeight,

      tree_width: window.innerWidth>1080? window.innerWidth*0.6 : window.innerWidth,
      tree_height: window.innerHeight>600?
        window.innerHeight : 600,
    }
  },

  created() {
    window.addEventListener("resize", this.resize)
    this.setData()
  },

  mounted() {
    this.reloadData()
  },

  destroyed() {
    window.removeEventListener("resize", this.resize)
  },

  computed: {
    ...mapGetters({
      drawer: 'welcome/drawer',
    })
  },

  methods: {
    register() {
      let access_token = this.$store.getters['auth/access_token']
      if (!!access_token) {
        this.$router.push({name: 'lab'})
      }
      else {
        this.$store.commit('welcome/setEmail', this.email)
        this.$router.push({name: 'signup'})
      }
    },

    reloadData() {
      let vm = this
      setInterval(
        function() {
          vm.setData()
        }, 10000
      )
    },

    setData() {
      let vm = this
      let original_trees = JSON.parse(this.trees)
      let original_tree = original_trees[Math.floor(Math.random() * original_trees.length)]
      let original_tree_width = original_tree.frame.width
      let original_tree_height = original_tree.frame.height
      
      let nodes = original_tree.nodes
      let links = original_tree.edges

      // Set the tree size
      let rate_x = this.tree_width*0.95 / original_tree_width
      let rate_y = this.tree_height / original_tree_height
      nodes.forEach(function(node) {
        node.x = rate_x*node.x + vm.tree_width * 0.5
        node.y = vm.tree_height-(rate_y*node.y)
      })

      // Change each link to have node details
      links.forEach(function(link) {
        link.source = nodes[nodes.map(node => node.doc_key).indexOf(link.source)]
        link.target = nodes[nodes.map(node => node.doc_key).indexOf(link.target)]
      })

      this.nodes = nodes
      this.links = links

      this.setNodeColor()
      this.tree_key += 1
    },

    setNodeColor() {
      let keys = Object.keys(this.doc_types)
      this.node_colors = {}
      for (let i=0; i<keys.length; i++) {
        this.node_colors[keys[i]] = this.doc_types[keys[i]].color
      }
      this.nodes.forEach(function(node) {
        node.attributes.color_index = keys[Math.floor(Math.random() * keys.length)]
      })
    },

    resize() {
      this.screen_width = window.innerWidth
      this.screen_height = window.innerHeight
      this.tree_width = window.innerWidth>1080? window.innerWidth*0.6 : window.innerWidth
      this.tree_height = window.innerHeight>600 ? window.innerHeight : 600
      this.setData()
    },

    gaClick(param) {
      this.$analytics.logEvent('click', { name: param })
    },
  }
}
</script>

<style scoped>
  #welcome-wrap {
    background-color: white;
  }
  /* Background image */

  .intro-background-image {
    position: absolute;
    z-index: 0;
    top: 0;
    right: 0;
    animation: fade-in 2s ease;
    display: flex;
    justify-content: flex-end;
  }

  .line {
    stroke: #999;
    stroke-width: 0.2px;
  }

  /* Contents */

  .contents {
    -moz-box-align: center;
    -moz-box-orient: vertical;
    -ms-flex-align: center;
    -ms-flex-direction: column;
    -o-box-align: center;
    -o-box-orient: vertical;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 1080px;
    min-width: 327px;
    width: 95%;
    height: auto !important;
  }

  .section-intro {
    -moz-box-align: center;
    -moz-box-orient: horizontal;
    -moz-box-pack: justify;
    -ms-flex-align: center;
    -ms-flex-direction: row;
    -ms-flex-pack: justify;
    -o-box-align: center;
    -o-box-orient: horizontal;
    -o-box-pack: justify;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -webkit-box-orient: horizontal;
    -webkit-box-pack: justify;
    -webkit-flex-direction: row;
    -webkit-justify-content: space-between;
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    flex-direction: row;
    height: 100vh;
    justify-content: space-between;
    min-height: 600px;
    width: 100%;
  }

  .intro {
    position: relative;
    max-width: 450px;
    width: 40%;
    z-index: 1;
    background-color: rgba(255,255,255,0.6);
  }

  .intro-title {
    text-align: left;
    font: normal 500 54px/64px 'Spoqa Han Sans', 'Sans-serif' !important;
    letter-spacing: -.4px;
  }

  .intro-subtitle {
    margin-top: 26px;
    font: normal 400 21px/36px 'Spoqa Han Sans', 'Sans-serif' !important;
  }

  .intro-btn {
    margin-top: 60px;
  }

  /* Fetures */

  .section-feature {
    -moz-box-align: center;
    -moz-box-orient: horizontal;
    -moz-box-pack: justify;
    -ms-flex-align: center;
    -ms-flex-direction: row;
    -ms-flex-pack: justify;
    -o-box-align: center;
    -o-box-orient: horizontal;
    -o-box-pack: justify;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -webkit-box-orient: horizontal;
    -webkit-box-pack: justify;
    -webkit-flex-direction: row;
    -webkit-justify-content: space-between;
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 60px;
    margin-top: 80px;
    width: 100%;
  }

  .feature-image-wrapper {
    -moz-box-align: center;
    -moz-box-orient: horizontal;
    -moz-box-pack: justify;
    -ms-flex-align: center;
    -ms-flex-direction: row;
    -ms-flex-pack: justify;
    -o-box-align: center;
    -o-box-orient: horizontal;
    -o-box-pack: justify;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -webkit-box-orient: horizontal;
    -webkit-box-pack: justify;
    -webkit-flex-direction: row;
    -webkit-justify-content: space-between;
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 110px;
    margin-top: 125px;
    width: 100%;
    position: relative;
    z-index: 1;
  }

  .feature-image-wrapper-right {
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
  }

  .feature-image {
    border-radius: 10px;
    height: 333.3px;
    width: 488px;
    clip-path: inset(0 0 0 0 round 10px 10px 10px 10px);
    border: 7px solid #1c1e29;
  }

  .feature-text-left {
    margin-left: 22px;
    max-width: 430px;
    position: relative;
    width: 65%;
    z-index: 1;
  }

  .feature-text-right {
    margin-right: 22px;
    max-width: 430px;
    position: relative;
    width: 65%;
    z-index: 1;
  }

  .text-category {
    -moz-box-align: start;
    -ms-flex-align: start;
    -o-box-align: start;
    -webkit-align-items: flex-start;
    -webkit-box-align: start;
    align-items: flex-start;
    color: #1c1e29;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    font: 700 11px/16px 'Spoqa Han Sans', 'Sans-serif' !important;
    letter-spacing: .9px;
    text-transform: uppercase;
  }

  .text-title {
    margin: 14px 0 0;
    font: normal 500 40px/48px 'Spoqa Han Sans', 'Sans-serif' !important;
    letter-spacing: -.2px;
  }

  .text-subtitle {
    margin-top: 35px;
    max-width: 455px;
    font: normal 400 21px/36px 'Spoqa Han Sans', 'Sans-serif' !important;
    letter-spacing: -.3px;
    word-break: keep-all;
  }
  .text-subtitle-big {
    margin-top: 45px;
    max-width: 600px;
    font:normal 400 24px/45px 'Spoqa Han Sans', 'Sans-serif' !important;
    word-break: keep-all;
  }

  .section-welcome {
    -moz-box-align: center;
    -moz-box-orient: vertical;
    -ms-flex-align: center;
    -ms-flex-direction: column;
    -o-box-align: center;
    -o-box-orient: vertical;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    flex-direction: column;
    margin: 80px 0 150px;
    text-align: center;
    width: 100%;
    position: relative;
    z-index: 1;
  }

  @media (max-width: 1080px) {
    .contents {
      padding-bottom: 50px;
    }

    .section-intro, .section-feature {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .section-feature, .section-welcome {
      margin-top: 50px;
      margin-bottom: 0px;
    }

    .section-feature-right {
      flex-direction: column-reverse;
    }

    .intro, 
    .feature-text {
      width: 100%;
    }

    .intro-title {
      font-size: 42px !important;
      margin-top: 27px;
      text-align: center;
    }

    .text-category {
      justify-content: center;
    }

    .text-title {
      font-size: 34px !important;
      margin-top: 27px;
      text-align: center;
    }

    .intro-subtitle, .text-subtitle {
      font-size: 18px !important;
      line-height: 32px;
      text-align: center;
    }

    .intro-btn {
      display: flex;
      justify-content: center;
      margin-top: 30px;
    }

    .feature-image-wrapper {
      justify-content: center;
      margin-top: 61px;
      margin-bottom: 0;
    }

    .feature-text-left, .feature-text-right {
      margin: 0;
      width: 100%;
    }
  }

  @media only screen and (max-width: 550px) {
    .section-intro, .section-feature {
      width: 327px;
    }

    .feature-image {
      border-radius: 5px;
      height: 225px;
      width: 327px;
    }
  }

  @keyframes fade-in {
      0% {
          opacity: 0;
      }
      100% {
          opacity: 1;
      }
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/welcome/Layout.vue